import { styled } from "nativewind";
import { TextInput } from "react-native";

export default styled(TextInput, "bg-white p-2 min-w-min max-w-full w-60");
